// import React from "react";

// const CarBrandsSection = () => {
//   return (
//     <div
//       className="section-full site-bg-white twm-carbrands-section-wrap wow fadeInDown"
//       data-wow-offset="100"
//       data-wow-delay="0.2"
//     >
//       <div className="row twm-carbrands">
        
//         {/* Left Image */}
//         <div className="col-lg-6 col-md-12">
//           <div className="twm-carbrands-l-pic">
//             <div className="twm-media">
//               <img src="images/car.png" alt="Bike Pic" />
//             </div>
//           </div>
//         </div>

//         {/* Right Content */}
//         <div className="col-lg-6 col-md-12">
//           <div className="twm-carbrands-section">
            
//             {/* Title */}
//             <div className="section-head left">
//               <div className="twm-sm-title left">Car Brands</div>
//               <h2 className="twm-large-title site-text-dark">
//                 A Range Of Premium Brand Bikes And Cars Available For Rent
//               </h2>
//             </div>

//             {/* Brand Logos */}
//             <div className="twm-carbrands-list">
//               <ul>
//                 <li>
//                   <a href="cars-grid-4.html">
//                     <img src="images/client-logo/dark/w1.png" alt="Brand 1" />
//                   </a>
//                 </li>

//                 <li>
//                   <a href="cars-grid-4.html">
//                     <img src="images/client-logo/dark/w2.png" alt="Brand 2" />
//                   </a>
//                 </li>

//                 <li>
//                   <a href="cars-grid-4.html">
//                     <img src="images/client-logo/dark/w3.png" alt="Brand 3" />
//                   </a>
//                 </li>

//                 <li>
//                   <a href="cars-grid-4.html">
//                     <img src="images/client-logo/dark/w4.png" alt="Brand 4" />
//                   </a>
//                 </li>

//                 <li>
//                   <a href="cars-grid-4.html">
//                     <img src="images/client-logo/dark/w5.png" alt="Brand 5" />
//                   </a>
//                 </li>

//                 <li>
//                   <a href="cars-grid-4.html">
//                     <img src="images/client-logo/dark/w6.png" alt="Brand 6" />
//                   </a>
//                 </li>
//               </ul>

            
//             </div>

//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default CarBrandsSection;








import React from "react";

const CarBrandsSection = () => {
  return (
    <div
      className="section-full site-bg-white twm-carbrands-section-wrap wow fadeInDown pt-5"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="row twm-carbrands">

        {/* Left Image */}
        <div className="col-lg-6 col-md-12">
          <div className="twm-carbrands-l-pic">
            <div className="twm-media">
              <img src="images/car.jpeg" alt="Cab Service" />
            </div>
          </div>
        </div>

        {/* Right Content */}
        <div className="col-lg-6 col-md-12">
          <div className="twm-carbrands-section">

            {/* Title */}
            <div className="section-head left">
              <div className="twm-sm-title left">Why Choose Us</div>
              <h2 className="twm-large-title site-text-dark">
                Your Trusted Partner for Safe & Reliable Cab Services
              </h2>
            </div>

            {/* Features List */}
            <div className="twm-carbrands-list">
              <ul>
                <li>✔ 24/7 Cab Availability</li>
                <li>✔ Professional & Verified Drivers</li>
                <li>✔ Clean & Well-Maintained Vehicles</li>
                <li>✔ Affordable & Transparent Pricing</li>
                <li>✔ Easy Booking & Quick Pickup</li>
                <li>✔ Outstation & Local Trips Available</li>
              </ul>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default CarBrandsSection;